export function mapNullable<TNullable, TResult>(
  v: TNullable | null,
  f: (t: TNullable) => TResult
): TResult | null {
  return v === null ? null : f(v)
}

export function mapNullable2<TNullable, TResult>(
  [v1, v2]: [TNullable | null, TNullable | null],
  f: (t: TNullable) => TResult
): [TResult, TResult] | null {
  return v1 === null || v2 === null ? null : [f(v1), f(v2)]
}
